import ChangeReservationCar from '@/components/edit-reservation/change-car';

export default ChangeReservationCar;
